import { Injectable } from '@angular/core';
import { EventContentArg } from '@fullcalendar/core';
import { IRelation } from '@whetstoneeducation/hero-common';
import { BaseService } from 'src/app/shared/base-classes/base.service';
import { CalendarViewOptionEnum } from '../calendar-view-models/calendar-view-options.enum';

@Injectable({
  providedIn: 'root'
})
export class AppCalendarViewHtmlContentService extends BaseService {
  public constructor() {
    super();
  }

  public getHtmlContent(props: EventContentArg): { html: string } {
    const { type } = props.event.extendedProps;
    if (type === CalendarViewOptionEnum.BELL_SCHEDULES) {
      return {
        html: this.getStudentBellScheduleHtmlContent(
          props.event.extendedProps.data
        )
      };
    }

    if (type === CalendarViewOptionEnum.REACTIONS) {
      return {
        html: this.getStudentScheduledReactionHtmlContent(
          props.event.extendedProps.data
        )
      };
    }

    if (type === CalendarViewOptionEnum.EVENTS) {
      return {
        html: this.getScheduledHeroEventHtmlContent(
          props.event.extendedProps.data
        )
      };
    }
  }

  private getStudentBellScheduleHtmlContent(
    studentBellSchedule: IRelation
  ): string {
    return `<div style="overflow: hidden">
              ${studentBellSchedule.name}
            </div>`;
  }

  private getStudentScheduledReactionHtmlContent(
    scheduledReaction: IRelation
  ): string {
    return `<div style="overflow: hidden">
               ${scheduledReaction.name}
            </div>`;
  }

  private getScheduledHeroEventHtmlContent(heroEvent: IRelation): string {
    return `<div style="overflow: hidden">
               ${heroEvent.name}
            </div>`;
  }
}
